import React, { useCallback, useEffect, useRef, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Header from '../../components/Header/Header';
// import googleads980 from '../../../assets/img/google-ads-930.jpg';
// import googleads300 from '../../../assets/img/google-ads-300.png';
import earlogo from '../../../assets/img/earlogo.svg';
import india from '../../../assets/img/india.svg';
import iconplay from '../../../assets/img/iconplay.svg';
import Footer from '../../components/Footer/Footer';
import dashedplay from '../../../assets/img/dashedplay.svg';
import usa from '../../../assets/img/usa.svg';
import uk from '../../../assets/img/uk.svg';
import '../../scss/Quiz.scss';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PlusIcon from '../../../assets/img/plus.png';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Mid_green_check from '../../../assets/img/mid-tick-green.svg';
import Red_tick from '../../../assets/img/red-cross-tick.svg';

import Circletick from '../../../assets/img/charm_cicle_tick.png';
import Circleinfo from '../../../assets/img/infoicon.svg';
import Circleincorrect from '../../../assets/img/incorrect.png';

import Thinking from '../../../assets/img/thinking.png';
import Sad from '../../../assets/img/sad.png';

import Star from '../../../assets/img/star.png';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Container,
  FormControl,
  Grid,
  Input,
  Box,
  Paper,
  Typography,
  SvgIcon,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useSelector } from 'react-redux';
import { fetchWordData } from '../../Utils/firebase-services';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomNoResponseModal from '../../components/CustomNoResponseModal';
import RemoteErrorLog from '../../Utils/api';
import { doc, getDoc } from '@firebase/firestore';
import { authen, db } from '../../firebase/firebase';
import { detectUserLanguages, Language } from '../../Utils/LanguageDetectionApi/Api';

const QuizResult = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const savedState = useRef(
    state || JSON.parse(localStorage.getItem('quizState') || '{}')
  );
  const { navigated }: any = savedState.current || {};
  const [questionAnswerData, setQuestionAnswerData] = useState<{
    [key: string]: string;
  }>();
  const currentAudio = useRef<HTMLAudioElement | null>(null);
  const [currentWordDetail, setCurrentWordDetail] = useState<any>();
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [description, setDescription] = useState<boolean>(true);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const questions = useSelector((state: any) => state.questions);
  const questionDetailData = useSelector((state: any) => state.questiondetail);
  const results = useSelector((state: any) => state.questionresult);

  const [documents, setDocuments] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [isQuestionModalVisible, setIsQuestionModalVisible] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState<string>('');
  const [pronunciationMode, setPronunciationMode] = useState(() => {
    const mode = localStorage.getItem('pronunciationMode');
    if (!mode) { return 'all'; }
    return mode;
  });
  const [isLoggedInViaSSO, setIsLoggedInViaSSO] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const [isSoundEnabled, setIsSoundEnabled] = useState(true);
  const [expandOptions, setExpandOptions] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(() => {
    return localStorage.getItem('selectedDefinitionLanguage') || 'default';
  });
  const [userLanguages, setUserLanguages] = useState<Language[]>([]);
  const [isLoadingLanguages, setIsLoadingLanguages] = useState(true);

  useEffect(() => {
  const checkSoundPreference = () => {
    const savedSoundPreference = localStorage.getItem('GlobalSoundsControl');
    setIsSoundEnabled(savedSoundPreference !== 'OFF');
  };

  checkSoundPreference();

  const handleStorageChange = (e: StorageEvent) => {
    if (e.key === 'GlobalSoundsControl') {
      setIsSoundEnabled(e.newValue !== 'OFF');
    }
  };

  window.addEventListener('storage', handleStorageChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
  }}, []);

  // Detect user languages based on country
  useEffect(() => {
    const loadUserLanguages = async () => {
      try {
        setIsLoadingLanguages(true);
        const response = await detectUserLanguages();
        setUserLanguages(response.languages);
        console.log('Detected user languages:', response.languages, 'for country:', response.country_code);
      } catch (error) {
        console.error('Error detecting user languages:', error);
        // Fallback to default languages
        setUserLanguages([
          { id: 'hindi', label: 'Hindi' },
          { id: 'spanish', label: 'Spanish' },
          { id: 'french', label: 'French' },
          { id: 'russian', label: 'Russian' },
          { id: 'bengali', label: 'Bengali' },
          { id: 'chinese', label: 'Chinese' },
          { id: 'arabic', label: 'Arabic' },
          { id: 'urdu', label: 'Urdu' },
          { id: 'haitian_creole', label: 'Haitian Creole' },
          { id: 'uzbek', label: 'Uzbek' },
          { id: 'tadzhik', label: 'Tadzhik' },
          { id: 'portuguese', label: 'Portuguese' }
        ]);
      } finally {
        setIsLoadingLanguages(false);
      }
    };

    loadUserLanguages();
  }, []);

  const playBubble = useCallback(() => {
      const currentSoundPreference = localStorage.getItem('GlobalSoundsControl');
      if (currentSoundPreference !== 'OFF') {
        try {
          const audio = new Audio('/assets/audio/bubble.mp3');
          audio.play().catch(error => {
            console.warn('Error playing bubble sound:', error);
          });
        } catch (error) {
          console.warn('Error creating audio:', error);
        }
      }
    }, []);

  const playCorrectSound = useCallback(() => {
    const currentSoundPreference = localStorage.getItem('GlobalSoundsControl');
    if (currentSoundPreference !== 'OFF') {
      try {
        const audio = new Audio('/assets/audio/correct.wav');
        audio.play().catch(error => {
          console.warn('Error playing correct sound:', error);
        });
      } catch (error) {
        console.warn('Error creating audio:', error);
      }
    }
  }, []);

  const playIncorrectSound = useCallback(() => {
    const currentSoundPreference = localStorage.getItem('GlobalSoundsControl');
    if (currentSoundPreference !== 'OFF') {
      try {
        const audio = new Audio('/assets/audio/incorrect.mp3');
        audio.play().catch(error => {
          console.warn('Error playing incorrect sound:', error);
        });
      } catch (error) {
        console.warn('Error creating audio:', error);
      }
    }
  }, []);

  const playAppropriateSound = useCallback(() => {
    const currentWord = questions[currentQuestionIndex];
    const userAnswer = results.result[currentWord];
    
    if (currentWord === userAnswer) {
      playCorrectSound();
    } else {
      playIncorrectSound();
    }
  }, [currentQuestionIndex, questions, results.result, playCorrectSound, playIncorrectSound]);

  useEffect(() => {
    if (questions[currentQuestionIndex] && results.result[questions[currentQuestionIndex]] !== undefined) {
      playAppropriateSound();
    }
  }, [currentQuestionIndex, playAppropriateSound]);

  useEffect(() => {
    const SSO_AUTH_TYPES = ['username', 'classlink-sso', 'clever-library', 'district-sso'];
    
    const fetchUserProfile = async () => {
      setIsProfileLoading(true);
      try {
        const docRef = doc(db, 'user_profile', authen?.currentUser?.uid || '');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const isSSO = SSO_AUTH_TYPES.includes(data.auth_type);
          setIsLoggedInViaSSO(isSSO);
          
          if (isSSO && !localStorage.getItem('pronunciationMode')) {
            setPronunciationMode('us');
            localStorage.setItem('pronunciationMode', 'us');
          }
        } else {
          setIsLoggedInViaSSO(false);
          setPronunciationMode('all');
        }
      } catch (error) {
        RemoteErrorLog(error, 'Quiz.tsx');
        setIsLoggedInViaSSO(false);
        setPronunciationMode('all');
      } finally {
        setIsProfileLoading(false);
      }
    };

    if (authen?.currentUser?.uid) {
      fetchUserProfile();
    } else {
      setIsProfileLoading(false);
      setIsLoggedInViaSSO(false);
      setPronunciationMode('all');
    }
}, []);

  useEffect(() => {
    setIsLoading(true);
    if (navigated) {
      if (questionDetailData?.detail && questions?.[currentQuestionIndex]) {
        const value =
          questionDetailData?.detail?.[questions?.[currentQuestionIndex]];
        setCurrentWordDetail(value);
        setIsLoading(false);
      } else if (documents && documents[questions?.[currentQuestionIndex]]) {
        const value = documents[questions?.[currentQuestionIndex]];
        setCurrentWordDetail(value);
        setIsLoading(false);
      } else {
        fetchWordData(questions[currentQuestionIndex])
          .then((wordField: any) => {
            if (wordField) {
              const currentWordData = {
                [questions[currentQuestionIndex]]: wordField,
              };

              setCurrentWordDetail(wordField);
              setDocuments((prevState: any) => ({
                ...prevState, // Spread the previous state to maintain its values
                ...currentWordData, // Spread the new value to add it to the state
              }));
            }
          })
          .finally(() => setIsLoading(false));
      }
    } else {
      navigate('/home');
    }
    if (questions.length == 0) {
      navigate('/home');
    }
  }, [currentQuestionIndex]);

  useEffect(() => {
    const qnaData = questions.reduce(
      (accumulator: any, currentValue: string) => {
        accumulator[currentValue] = '';
        return accumulator;
      },
      {}
    );
    setQuestionAnswerData(qnaData);
  }, [questions]);

  useEffect(() => {
    getCurrentQuestionData();
  }, [currentQuestionIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds < 59) {
        setSeconds(seconds + 1);
      } else {
        setSeconds(0);
        setMinutes(minutes + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, minutes]);

  const goToNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const goToPreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const getCurrentQuestionData = async () => {
    const currentWordName = questions[currentQuestionIndex];
    const wordDetails = documents?.[currentWordName];
    if (wordDetails) {
      setCurrentWordDetail(wordDetails);
    }
  };
  const handlePronunciationModeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMode = e.target.value;
    setPronunciationMode(newMode);
    localStorage.setItem('pronunciationMode', newMode);
  };

  const base64ToBlob = (base64Data: string, contentType = 'audio/wav') => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  const playSound = async (base64Sound: string, speed?: number) => {
    try {
      if (currentAudio.current) {
        currentAudio.current.pause();
        currentAudio.current.currentTime = 0;
      }
      const audioBlob = base64ToBlob(base64Sound);
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      if (speed) {
        audio.playbackRate = speed;
      }
      currentAudio.current = audio;
      audio.onended = () => {
        URL.revokeObjectURL(audioUrl);
        currentAudio.current = null;
      };
      
      audio.onerror = (error) => {
        URL.revokeObjectURL(audioUrl);
        currentAudio.current = null;
      };

      await audio.play();
    } catch (error) {
      RemoteErrorLog(error, 'Quiz.tsx');
    }
  };

  // const playDynamicSound = useCallback(
  //   async (countryCode: number, playbackSpeed: any) => {
  //     const speedValue = Number(playbackSpeed);

  //     try {
  //       let base64Audio;
  //       switch (countryCode) {
  //         case 1:
  //           base64Audio = currentWordDetail?.audio_IN;
  //           break;
  //         case 2:
  //           base64Audio = currentWordDetail?.audio_US;
  //           break;
  //         case 3:
  //           base64Audio = currentWordDetail?.audio_UK;
  //           break;
  //         default:
  //           throw new Error('Invalid country code');
  //       }

  //       if (!base64Audio) {
  //         throw new Error('No audio data available');
  //       }

  //       const audioBlob = base64ToBlob(base64Audio);
  //       const audioUrl = URL.createObjectURL(audioBlob);
  //       const audio = new Audio(audioUrl);

  //       audio.playbackRate = speedValue;

  //       audio.onended = () => {
  //         URL.revokeObjectURL(audioUrl);
  //       };

  //       audio.onerror = (error) => {
  //         URL.revokeObjectURL(audioUrl);
  //       };

  //       await audio.play();
  //     } catch (error) {
  //       RemoteErrorLog(error, 'QuizResult.tsx');
  //     }
  //   },
  //   [currentWordDetail]
  // );
  const hideModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hideNoQuestionModal = () => {
    setIsQuestionModalVisible(false);
  };

  const renderPronunciationButtons = () => {
    const accents = [
      { label: "India", audio: "audio_IN", flag: india },
      { label: "USA", audio: "audio_US", flag: usa },
      { label: "UK", audio: "audio_UK", flag: uk }
    ];
  
    const renderAccentBox = (
      label: string,
      audio: string,
      flag: string,
      speed?: number
    ) => {
      let speedLabel = "";
      if (speed) {
        if (speed === 1) speedLabel = "Normal Speed";
        else if (speed === 0.75) speedLabel = "Medium Speed";
        else if (speed === 0.5) speedLabel = "Slow Speed";
      }
      
      return (
        <Box className="accent-box cursor-pointer" onClick={() => playSound(currentWordDetail?.[audio], speed)}>
          <Box>
            <Typography variant="body1" className="font-600 text-light">{label}</Typography>
          </Box>
          <Box className="play-inside-img">
            <img src={flag} alt={label} className="flag" />
            <Button style={{ padding: 0, minWidth: 'auto' }}>
              <img src={speed ? dashedplay : iconplay} alt="Play" className={speed ? "btn-slow" : "btn-speaker"} />
            </Button>
          </Box>
          {speed && (
            <Typography variant="body2" className="text-right text-light font-600 slow-speed">
              {speedLabel}
            </Typography>
          )}
        </Box>
      );
    };
  
    if (isLoggedInViaSSO && pronunciationMode === 'us') {
      return (
        <Box className="accent-grid-type">
          {renderAccentBox("USA", "audio_US", usa, 1)}
          {renderAccentBox("USA", "audio_US", usa, 0.75)}
          {renderAccentBox("USA", "audio_US", usa, 0.5)}
        </Box>
      );
    }
  
    return (
      <Box className="accent-grid-type">
        {accents.map(({ label, audio, flag }) => renderAccentBox(label, audio, flag, 1))}
        {accents.map(({ label, audio, flag }) => renderAccentBox(label, audio, flag, 0.5))}
      </Box>
    );
  };

  return (
    <Box>
      <Navbar />
      <Header />

      <main className="page-bg overflow-hidden">
        <Container
          sx={{
            maxWidth: { xs: '100%', sm: '95%', md: '1460px' },
          }}
        >
          {/* <Box className="googleAds top mx-auto">
            <img src={googleads980} alt="" />
          </Box> */}
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: 'center !important' }}
          >
            {/* <Grid item lg={3} xs={12} sx={{ textAlign: 'center' }} className='order-item-2'>
              <Box className="googleAds top mx-auto">
                <img src={googleads300} alt="" />
              </Box>
            </Grid> */}
            <Grid item lg={6} xs={12}>
              {isLoading ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                  }}
                >
                  {' '}
                  <CircularProgress
                    size={56}
                    sx={{
                      color: 'primary.main',
                    }}
                  />{' '}
                </Box>
              ) : (
                <section className="quiz-step">
                  <Typography variant="h3">Let’s Spell!</Typography>
                  <Paper className="box-container quiz-container">
                    <Typography
                      sx={{
                        textAlign: 'right',
                        marginRight: '12px',
                        marginTop: '5px',
                      }}
                    >
                      {currentQuestionIndex + 1}/{questions.length}
                    </Typography>

                    <Box className="round-quiz result-quiz">
                      <ul>
                        {Object.entries(results.result).map(
                          ([key, value], index) => {
                            const isCorrect = key === value;
                            return (
                              <li
                                className={`${isCorrect ? '' : 'red-box'} `}
                              ></li>
                            );
                          }
                        )}
                      </ul>
                    </Box>
                    <Box className="d-flex justify-content-between align-items-center mt-3">
                      <Box>
                        <Typography
                          variant="body1"
                          className="font-400 text-blackish"
                        >
                          <img
                            width={30}
                            className="me-2 align-middle"
                            src={earlogo}
                            alt=" "
                          />
                          Click a button below to listen to the Indian, USA or
                          UK accent.
                        </Typography>
                      </Box>
                    </Box>
  
                    {!isProfileLoading && isLoggedInViaSSO && (
                      <Box sx={{ marginBottom: '15px', marginTop: '10px' }}>
                        <FormControl>
                          <RadioGroup 
                            row 
                            value={pronunciationMode} 
                            onChange={handlePronunciationModeChange}
                          >
                            <FormControlLabel 
                              value="us" 
                              control={
                                <Radio
                                  sx={{
                                    '&.Mui-checked': {
                                      color: 'green',
                                    },
                                    '& .MuiTouchRipple-root': {
                                      color: 'green',
                                    }
                                  }}
                                />
                              }
                              label="USA Speech" 
                            />
                            <FormControlLabel 
                              value="all" 
                              control={
                                <Radio
                                  sx={{
                                    '&.Mui-checked': {
                                      color: 'green',
                                    },
                                    '& .MuiTouchRipple-root': {
                                      color: 'green',
                                    }
                                  }}
                                />
                              }
                              label="Global Speech" 
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    )}

                    <Box sx={{ marginBottom: isLoggedInViaSSO ? '15px' : '25px' }} />

                    {renderPronunciationButtons()}
  
                    <Accordion
                      expanded={description}
                      onClick={() => setDescription(!description)}
                      className="part-speech-card"
                    >
                      <AccordionSummary
                        expandIcon={
                          description ? (
                            <SvgIcon className="part-speech-svg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <circle
                                  cx="15"
                                  cy="15"
                                  r="15"
                                  fill="#5FCD6A"
                                  fill-opacity="0.5"
                                />
                                <path
                                  d="M9.16797 15H20.8346"
                                  stroke="#2A9235"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          ) : (
                            <img src={PlusIcon} />
                          )
                        }
                      >
                        <Typography
                          variant="h4"
                          className="mb-0 text-para-black font-22 font-500"
                        >
                          Part of Speech:
                          <span className="font-400 ps-2">
                            <i> {currentWordDetail?.part_of_speech}</i>
                          </span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: '0px 16px 5px !important' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography variant="h4" className="font-22 font-500">
                              Description:
                            </Typography>
                            <Box 
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandOptions(!expandOptions);
                              }} 
                              sx={{ 
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                color: '#0095D9'
                              }}
                            >
                              <Typography 
                                variant="h4"
                                className="font-600"
                                sx={{ 
                                  fontSize: '16px',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {selectedLanguage === 'default' ? 'English' : selectedLanguage.split('_').map(word => 
                                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                ).join(' ')}
                              </Typography>
                              {expandOptions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </Box>
                          </Box>
                          
                          <Typography variant="body1" className="text-para-black">
                            {selectedLanguage === 'default' && currentWordDetail?.ai_definition}
                            {selectedLanguage === 'hindi' && currentWordDetail?.hindi_definition}
                            {selectedLanguage === 'bengali' && currentWordDetail?.bengali_definition}
                            {selectedLanguage === 'punjabi' && currentWordDetail?.punjabi_definition}
                            {selectedLanguage === 'gujarati' && currentWordDetail?.gujarati_definition}
                            {selectedLanguage === 'marathi' && currentWordDetail?.marathi_definition}
                            {selectedLanguage === 'telugu' && currentWordDetail?.telugu_definition}
                            {selectedLanguage === 'tamil' && currentWordDetail?.tamil_definition}
                            {selectedLanguage === 'kannada' && currentWordDetail?.kannada_definition}
                            {selectedLanguage === 'urdu' && currentWordDetail?.urdu_definition}
                            {selectedLanguage === 'spanish' && currentWordDetail?.spanish_definition}
                            {selectedLanguage === 'chinese' && currentWordDetail?.chinese_definition}
                            {selectedLanguage === 'arabic' && currentWordDetail?.arabic_definition}
                            {selectedLanguage === 'russian' && currentWordDetail?.russian_definition}
                            {selectedLanguage === 'haitian_creole' && currentWordDetail?.haitian_creole_definition}
                            {selectedLanguage === 'uzbek' && currentWordDetail?.uzbek_definition}
                            {selectedLanguage === 'french' && currentWordDetail?.french_definition}
                            {selectedLanguage === 'tadzhik' && currentWordDetail?.tadzhik_definition}
                          </Typography>

                          {expandOptions && (
                            <Box 
                              onClick={(e) => e.stopPropagation()}
                              sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '16px',
                                padding: '16px',
                                backgroundColor: 'rgba(95, 205, 106, 0.08)',
                                borderRadius: '4px',
                                width: '100%'
                              }}
                            >
                              <Typography 
                                variant="h4"
                                className="font-600"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedLanguage('default');
                                  setExpandOptions(false);
                                  localStorage.setItem('selectedDefinitionLanguage', 'default');
                                }}
                                sx={{ 
                                  cursor: 'pointer',
                                  color: selectedLanguage === 'default' ? '#0095D9' : 'inherit',
                                  '&:hover': { color: '#0095D9' },
                                  fontSize: '16px'
                                }}
                              >
                                English
                              </Typography>
                              {isLoadingLanguages ? (
                                <CircularProgress size={20} />
                              ) : (
                                (localStorage.getItem('userAuthType') === 'username' ? [
                                  { id: 'hindi', label: 'Hindi' },
                                  { id: 'bengali', label: 'Bengali' },
                                  { id: 'punjabi', label: 'Punjabi' },
                                  { id: 'gujarati', label: 'Gujarati' },
                                  { id: 'marathi', label: 'Marathi' },
                                  { id: 'telugu', label: 'Telugu' },
                                  { id: 'tamil', label: 'Tamil' },
                                  { id: 'kannada', label: 'Kannada' }
                                ] : userLanguages).map((language) => (
                                <Typography 
                                  key={language.id}
                                  variant="h4"
                                  className="font-600"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedLanguage(language.id);
                                    setExpandOptions(false);
                                    localStorage.setItem('selectedDefinitionLanguage', language.id);
                                  }}
                                  sx={{ 
                                    cursor: 'pointer',
                                    color: selectedLanguage === language.id ? '#0095D9' : 'inherit',
                                    '&:hover': { color: '#0095D9' },
                                    fontSize: '16px'
                                  }}
                                >
                                  {language.label}
                                </Typography>
                                ))
                              )}
                            </Box>
                          )}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                    {questions[currentQuestionIndex] ===
                      results.result[questions[currentQuestionIndex]] && (
                      <Box>
                        <Box className="accomplish-section">
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={Mid_green_check}
                              className="ps-2"
                              alt=""
                            />
                            <Typography variant="h4" sx={{ fontSize: '16px' }}>
                              {results.result[questions[currentQuestionIndex]]}
                            </Typography>
                          </Box>
                          <Typography
                            className="font-600"
                            variant="h4"
                            sx={{ fontSize: '16px' }}
                          >
                            <span style={{ color: '#2A9235' }}>(Correct)</span>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            background: '#5FCD6A1A',
                            marginTop: '20px',
                            padding: '7px 12px 7px 16px',
                            display: 'flex',
                            gap: '11px',
                          }}
                        >
                          <img src={Circletick} alt="green-tick" />
                          <Typography
                            variant="h4"
                            sx={{
                              fontSize: '14px',
                              fontWeight: '500',
                              fontFamily: 'poppins',
                            }}
                          >
                            Well done! You got this right.
                          </Typography>
                          <img src={Star} alt="green-tick" />
                        </Box>
                      </Box>
                    )}
                    {questions[currentQuestionIndex] !==
                      results.result[questions[currentQuestionIndex]] &&
                      results.result[questions[currentQuestionIndex]] !==
                        '' && (
                        <Box>
                          <Box className="accomplish-section border-red-incorrect">
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 1,
                                alignItems: 'center',
                              }}
                            >
                              <img src={Red_tick} className="ps-2" alt="" />
                              <Typography
                                variant="h4"
                                sx={{ fontSize: '16px' }}
                              >
                                {
                                  results.result[
                                    questions[currentQuestionIndex]
                                  ]
                                }
                              </Typography>
                            </Box>
                            <Typography
                              className="font-600"
                              variant="h4"
                              sx={{ fontSize: '16px' }}
                            >
                              <span style={{ color: '#CF232A' }}>
                                (Incorrect)
                              </span>
                            </Typography>
                          </Box>
                          <Box className="accomplish-section">
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 1,
                                alignItems: 'center',
                              }}
                            >
                              <img
                                src={Mid_green_check}
                                className="ps-2"
                                alt=""
                              />
                              <Typography
                                variant="h4"
                                sx={{ fontSize: '16px' }}
                              >
                                {questions[currentQuestionIndex]}
                              </Typography>
                            </Box>
                            <Typography
                              className="font-600"
                              variant="h4"
                              sx={{ fontSize: '16px' }}
                            ></Typography>
                          </Box>
                          <Box
                            sx={{
                              background: '#EC1C241A',
                              marginTop: '20px',
                              padding: '7px 12px 7px 16px',
                              display: 'flex',
                              gap: '11px',
                            }}
                          >
                            <img
                              src={Circleincorrect}
                              alt="green-tick"
                              style={{ height: 18, width: 18 }}
                            />
                            <Typography
                              variant="h4"
                              sx={{
                                fontSize: '14px',
                                fontWeight: '500',
                                fontFamily: 'poppins',
                              }}
                            >
                              Sorry, you didn't get this right.
                            </Typography>
                            <img
                              src={Sad}
                              alt="green-tick"
                              style={{ width: 15, height: 15 }}
                            />
                          </Box>
                        </Box>
                      )}
                    {results.result[questions[currentQuestionIndex]] === '' && (
                      <Box>
                        <Box className="accomplish-section border-red-incorrect">
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            <img src={Red_tick} className="ps-2" alt="" />
                            <Typography
                              variant="h4"
                              sx={{ fontSize: '16px' }}
                            ></Typography>
                          </Box>
                          <Typography
                            className="font-600"
                            variant="h4"
                            sx={{ fontSize: '16px' }}
                          >
                            <span style={{ color: '#CF232A' }}>
                              (Not attempted)
                            </span>
                          </Typography>
                        </Box>
                        <Box className="accomplish-section">
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={Mid_green_check}
                              className="ps-2"
                              alt=""
                            />
                            <Typography variant="h4" sx={{ fontSize: '16px' }}>
                              {questions[currentQuestionIndex]}
                            </Typography>
                          </Box>
                          <Typography
                            className="font-600"
                            variant="h4"
                            sx={{ fontSize: '16px' }}
                          ></Typography>
                        </Box>
                        <Box
                          sx={{
                            background: '#EC1C241A',
                            marginTop: '20px',
                            padding: '7px 12px 7px 16px',
                            display: 'flex',
                            gap: '11px',
                          }}
                        >
                          <img
                            src={Circleinfo}
                            alt="green-tick"
                            style={{ height: 15, width: 15 }}
                          />
                          <Typography
                            variant="h4"
                            sx={{
                              fontSize: '14px',
                              fontWeight: '500',
                              fontFamily: 'poppins',
                            }}
                          >
                            You didn't answer this question.
                          </Typography>
                          <img
                            src={Thinking}
                            alt="green-tick"
                            style={{ width: 15, height: 15 }}
                          />
                        </Box>
                      </Box>
                    )}

                    <Box
                      className="d-flex  gap-3 pt-4 flex-wrap btn-combo "
                      sx={{ paddingBottom: '15px', paddingTop: '15px' }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={
                          <ArrowBackIosIcon className="custom-icon-class" />
                        }
                        className="btn-quiz-next btn-previous-quiz"
                        onClick={goToPreviousQuestion}
                      >
                        Previous
                      </Button>
                      {currentQuestionIndex + 1 !== questions.length && (
                        <Button
                          variant="contained"
                          className="btn btn-primary btn-quiz-next "
                          endIcon={<NavigateNextIcon />}
                          onClick={goToNextQuestion}
                        >
                          Next
                        </Button>
                      )}
                      {currentQuestionIndex + 1 === questions.length && (
                        <Button
                          variant="contained"
                          className="btn btn-primary btn-quiz-next "
                          onClick={() =>
                            navigate('/result', {
                              state: { navigated: true },
                            })
                          }
                        >
                          Done
                        </Button>
                      )}
                    </Box>
                  </Paper>
                  <CustomNoResponseModal
                    isModalVisible={isQuestionModalVisible}
                    onPress={hideNoQuestionModal}
                    buttonText="OK"
                    modalTitle="Oops!"
                    text={apiErrorMessage}
                  />
                </section>
              )}
            </Grid>
            {/* <Grid
              item
              lg={3}
              xs={12}
              className="pb-3"
              sx={{ textAlign: 'center' }}
            >
              <Box className="googleAds top mx-auto">
                <img src={googleads300} alt="" />
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </main>
      <Footer />
    </Box>
  );
};

export default QuizResult;
